<template>
  <b-card no-body v-if="this.tripData">
    <b-card-body>
      <b-container fluid="xl">
        <b-modal v-model="modalVisible" v-if="media" @close="modalVisible = false" size="lg" hide-header hide-footer hide-header-close>
          <img :src="media" width="750" height="421" />
          <p />
          <base-button size="sm" type="danger" @click.native="deleteMedia()">
            Delete
          </base-button>
        </b-modal>
        <b-modal v-model="modalVisible" v-if="mediaVideo && mediaOptions" @close="modalVisible = false" size="lg" hide-header hide-footer hide-header-close>
          <video-player class="video-player-box" ref="videoPlayer" :options="mediaOptions" />
          <p />
          <base-button size="sm" type="danger" @click.native="deleteMedia()">
            Delete
          </base-button>
        </b-modal>
        <b-modal
          v-model="showFileupload"
          id="add-attachments-modal"
          centered
          hide-footer
          title="File(s) Upload"
          :size="filelist.length ? 'lg' : ''">
          <b-form @submit="onSubmit">
            <b-row class="mt-2 px-3">

              <!--the file list column has different width based on boreakpoint-->
              <!--and is shown only if one or more files are selected-->
              <b-col sm="12" xl="8" v-if="this.filelist.length" v-cloak>

                <!--show a list of the selected files, with an input to (optionally) rename the file before upload-->
                <b-list-group>
                  <b-list-group-item class="d-inline-flex p-2" v-for="(file, i) in filelist" :key="i">

                    <!--file name input to rename the file before upload-->
                    <b-form-input
                      placeholder="File name..."
                      v-model="filelist[i].fileName"
                      required
                    />

                    <!--file extension-->
                    <span class="d-inline-flex align-items-center text-muted ml-1 mr-3">.{{ filelist[i].extension }}</span>

                    <!--remove file from list (and from upload)-->
                    <b-button variant="outline-danger" size="sm" @click="remove(filelist.indexOf(file))">
                      <b-icon-trash></b-icon-trash>
                    </b-button>

                  </b-list-group-item>
                </b-list-group>

              </b-col>

              <!--this column contains the file drop area-->
              <!--its width is automatically set based on existance of the file list column and breakpoint-->
              <b-col class="file-drop-column my-4 my-xl-0 p-0">
                <div class="file-drop-area bg-light" @dragover="dragover" @drop="drop">

                  <!--we need an actual file input in order to have the drag&drop functionality-->
                  <!--and the File object(s) containing the files dropped-->
                  <!--We keep it invisible because we want to display something different than a file input-->
                  <input type="file" multiple name="file-input" id="file-input"
                         class="file-input invisible" @change="onChange"/>

                  <!--clicking on this label will trigger the clicked event on the file input-->
                  <!--this will cause the 'choose file' system dialog-->
                  <label for="file-input" class="w-100 text-center cursor-pointer text-muted m-0 px-3 py-5">
                    <p>
                      <b-icon-cloud-upload-fill font-scale="3"></b-icon-cloud-upload-fill>
                    </p>
                    <div>
                      <p class=mb-0>Drop your file(s) here</p>
                      <p class=mb-0>or <span class=text-info>choose from computer</span></p>
                    </div>
                  </label>
                </div>
              </b-col>
            </b-row>

            <!--this div contains the two action buttons cancel and upload-->
            <!--It is totally possible to use the bootstrapvue footer buttons instead-->
            <div class="float-right mt-4">
              <b-button variant="secondary" @click="$bvModal.hide('add-attachments-modal')" class="mr-3">
                Cancel
              </b-button>
              <b-button type="submit" variant="success">
                Upload file(s)
              </b-button>
            </div>
          </b-form>
        </b-modal>
        <b-row align-v="center">
          <b-col cols="4">
            <h2>START</h2>
            <div>
              {{ $formatDate(new Date(this.tripData.startTime)) }}
            </div>
            <div>
              <h3>{{ $formatTime(new Date(this.tripData.startTime)) }}</h3>
            </div>
            {{ this.tripStartAddress }}
          </b-col>
          <b-col cols="4" align="center">
            <div v-if="this.type === 'ASSET'">
              <div  v-for="(item, index) in this.tripData.assetPeriodData[0].driverData">
                <div v-if="item.driverId !== 'UNKNOWN' || item.drivingStyleData.drivingDistance > 100">
                  <div v-if="item.driverId === 'UNKNOWN'">
                    {{ item.driverId }}
                  </div>
                  <div v-else>
                    <router-link :to="{ name: 'driver-detail', params: { type: 'DRIVER', entityId: item.driverId }}">
                      {{ item.driverName }}
                    </router-link>
                  </div>
                  <div v-if="item.drivingStyleData">
                    <div>
                      <div>
                        Drive distance
                      </div>
                      <div>
                        <h3>{{ $formatDistance(item.drivingStyleData.drivingDistance) }}</h3>
                      </div>
                    </div>
                    <div v-if="item.scoreData">
                      <div>
                        Driver score
                      </div>
                      <div>
                        <h3>{{ item.scoreData.totalScore }}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="this.type === 'DRIVER'">
              <router-link :to="{ name: 'asset-detail', params: { type: 'ASSET', entityId: this.tripData.driverPeriodData[0].assetData[0].assetId }}">
                {{ this.tripData.driverPeriodData[0].assetData[0].assetName }}
              </router-link>
              <div v-if="this.tripData.driverPeriodData[0].assetData[0].drivingStyleData">
                <div>
                  Drive distance
                </div>
                <div>
                  <h3>{{ $formatDistance(this.tripData.driverPeriodData[0].assetData[0].drivingStyleData.drivingDistance) }}</h3>
                </div>
              </div>
              <p/>
            </div>
            <div>
              <div>
                Total score
              </div>
              <div>
                <h3>{{ getScoreData.totalScore }}</h3>
              </div>
            </div>
            <p/>
            <p/>
            <base-button size="sm" type="primary" v-b-toggle="this.tripData.startTime" class="m-1">Details</base-button>
            <base-button size="sm" type="primary" v-b-toggle="this.tripData.endTime" class="m-1">Map</base-button>
          </b-col>
          <b-col cols="4" align="right">
            <h2>FINISH</h2>
            <div>
              {{ $formatDate(new Date(this.tripData.endTime)) }}
            </div>
            <div>
              <h3>{{ $formatTime(new Date(this.tripData.endTime)) }}</h3>
            </div>
            {{ this.tripEndAddress }}
          </b-col>
        </b-row>
      </b-container>
    </b-card-body>
    <b-collapse :id="this.tripData.startTime" v-observe-visibility="{ callback: setDetailsVisible }">
      <b-row cols="12" v-if="detailsVisible">
        <b-col cols="4">
          <b-card>
            Stats
            <stats-card :statsData="getDrivingStyleData"/>
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card>
            Score
            <score-card :scoreData="getScoreData"/>
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card v-if="loadEvents">
            Events
            <b-card-body >
              <div v-for="(datapoint, index) in this.events">
                <h3 v-for="(event, index) in datapoint.events" style="display: inline-block">{{ $formatTime(new Date(Date.parse(datapoint.timestamp))) }} : {{ event.eventType }}</h3>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-collapse>
    <b-collapse :id="this.tripData.endTime" v-observe-visibility="{ callback: setMapVisible }">
      <b-row cols="12" v-if="mapVisible">
        <b-col cols="4">
          <b-card v-if="loadDatapoints">
            Events
            <b-card-body >
              <div v-for="(datapoint, dataPointIndex) in this.datapoints">
                <h3 v-for="(event, eventIndex) in datapoint.events" style="display: inline-block" @mouseover="google && openInfoWindowTemplate(dataPointIndex, eventIndex)"><base-button size="sm" type="neutral" @click.native="uploadMedia(datapoint)"><img src="img/icons/common/upload.png"/></base-button>{{ $formatTime(new Date(Date.parse(datapoint.timestamp))) }} : {{ event.eventType }}&nbsp;</h3>
                <base-button v-for="(m, mediaIndex) in datapoint.media" size="sm" type="neutral" @click.native="openMedia(dataPointIndex, mediaIndex)" data-toggle="modal" data-target="#mediaModal" icon><img src="img/icons/common/camera-icon.png"/></base-button>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="8">
          <b-card v-if="loadDatapoints">
            Map
            <b-card-body ref="mapCard">
              <GmapMap
                ref="mapRef"
                :center="google && getEventsCenter(this.datapoints)"
                :zoom="12"
                map-type-id="roadmap"
                style="width: 920px; height: 510px"
                :options='{
                  zoomControl: true,
                  mapTypeControl: true,
                  scaleControl: false,
                  streetViewControl: true,
                  rotateControl: false,
                  fullscreenControl: true,
                  disableDefaultUi: false,
                  styles: [
                    {
                      featureType: "poi",
                      elementType: "all",
                      stylers: [{ visibility: "off" }],
                    }
                  ],
                }'
              >
                <GmapPolyline
                  v-if="route"
                  :path="route"
                  :editable="false",
                  :draggable="false"
                  :options='{
                    strokeColor: "blue"
                  }'
                />
                <GmapMarker
                  :position="google && getLatLngLiteral(tripData.startLocation)"
                  :clickable="false"
                  :draggable="false"
                  :icon="getMarkerIcon('START')"
                  :zIndex="1"
                />
                <!--
                <GmapInfoWindow
                  :options="{
                    maxWidth: 300,
                    pixelOffset: { width: 0, height: -35 }
                  }"
                  :position="google && getLatLngLiteral(tripData.startLocation)"
                  :opened="true"
                  :zIndex="0">
                    <div><b>{{ $formatTime(new Date(Date.parse(tripData.startTime))) }}</b><br><br>START<br></div>
                </GmapInfoWindow>
                -->
                <GmapMarker
                  :position="google && getLatLngLiteral(tripData.endLocation)"
                  :clickable="false"
                  :draggable="false"
                  :icon="getMarkerIcon('FINISH')"
                  :zIndex="1"
                />
                <!--
                <GmapInfoWindow
                  :options="{
                    maxWidth: 300,
                    pixelOffset: { width: 0, height: -35 }
                  }"
                  :position="google && getLatLngLiteral(tripData.endLocation)"
                  :opened="true"
                  :zIndex="0">
                  <div><b>{{ $formatTime(new Date(Date.parse(tripData.endTime))) }}</b><br><br>FINISH<br></div>
                </GmapInfoWindow>
                -->
                <div v-for="(datapoint, dataPointIndex) in this.datapoints">
                  <GmapMarker
                    v-for="(event, eventIndex) in datapoint.events"
                    :position="google && getLatLngLiteral(datapoint.location)"
                    :icon="getMarkerIcon(event.eventType)"
                    :clickable="true"
                    :draggable="false"
                    @click="openInfoWindowTemplate(dataPointIndex, eventIndex)"
                    :zIndex="0"
                  />
                </div>
                <GmapInfoWindow
                  :options="{
                    maxWidth: 300,
                    pixelOffset: { width: 0, height: -35 }
                  }"
                  :position="infoWindow.position"
                  :opened="infoWindow.open"
                  @closeclick="infoWindow.open=false"
                  :zIndex="1">
                  <div v-html="infoWindow.template"></div>
                </GmapInfoWindow>
              </GmapMap>
              <p/>
              <base-button size="sm" type="neutral" @click.native="handleCenter()">Center</base-button>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-collapse>
  </b-card>
</template>

<script>
import axios from "axios";
import crudApi from "../../crud/crud-api";
import StatsCard from "./StatsCard";
import ScoreCard from "./ScoreCard";
import {gmapApi} from 'vue2-google-maps'
import {formatTime} from "../../util/formatting";
import Modal from "../../components/Modal"
import FileUpload from "../../components/Inputs/FileUpload";
import 'video.js/dist/video-js.css'
import 'videojs-contrib-hls';
import { videoPlayer } from 'vue-video-player'

export default {
  name: "trip-card",
  props: {
    type: {
      type: String,
      default: 'ASSET',
      description: "Types : ASSET, DRIVER"
    },
    tripData: {
      type: Object,
      description: "Trip data object"
    }
  },
  components: {
    FileUpload,
    StatsCard,
    ScoreCard,
    Modal,
    videoPlayer
  },
  data: _ => ({
    detailsVisible: false,
    mapVisible: false,
    events: [],
    datapoints: [],
    tripStartAddress: {},
    tripEndAddress: {},
    route: [],
    media: undefined,
    mediaVideo: undefined,
    mediaOptions: undefined,
    downloadMediaId: undefined,
    modalVisible: false,
    showFileupload: false,
    filelist: [],
    uploadTimestamp: undefined,
    uploadIdentifier: undefined,
    infoWindow: {
      position: {lat: 0, lng: 0},
      open: false,
      template: ''
    }
  }),
  created() {
    this.reverseGeocodeData()
  },
  computed: {
    google: gmapApi,
    player() {
      return this.$refs.videoPlayer.player
    },
    getDrivingStyleData() {
      if (this.type === 'ASSET') {
        return this.tripData.assetPeriodData[0].drivingStyleData
      } else {
        return this.tripData.driverPeriodData[0].drivingStyleData
      }
    },
    getScoreData() {
      if (this.type === 'ASSET') {
        return this.tripData.assetPeriodData[0].scoreData
      } else {
        return this.tripData.driverPeriodData[0].scoreData
      }
    },
    loadEvents() {
      this.getEvents()

      return true
    },
    loadDatapoints() {
      this.getDatapoints()

      return true
    }
  },
  methods: {
    getEvents() {
      let id = undefined

      if (this.type === 'ASSET') {
        id = this.tripData.assetPeriodData[0].assetId
        crudApi.getAssetEvents(id, new Date(Date.parse(this.tripData.startTime)), new Date(Date.parse(this.tripData.endTime))).then(json => this.events = json.data ? json.data : json)
      } else {
        id = this.tripData.driverPeriodData[0].driverId
        crudApi.getDriverEvents(id, new Date(Date.parse(this.tripData.startTime)), new Date(Date.parse(this.tripData.endTime))).then(json => this.events = json.data ? json.data : json)
      }

      console.log("Loading events for : " + id)

      return true
    },
    getDatapoints() {
      let id = undefined

      if (this.type === 'ASSET') {
        id = this.tripData.assetPeriodData[0].assetId
      } else {
        id = this.tripData.driverPeriodData[0].assetData[0].assetId
      }
      crudApi.getAssetDatapoints(id, new Date(Date.parse(this.tripData.startTime)), new Date(Date.parse(this.tripData.endTime)), true, true).then(json => this.datapoints = json.data ? json.data : json)

      console.log("Loading datapoints for : " + id)

      return true
    },
    onSubmit() {
      event.preventDefault();
      this.showFileupload = false

      for (let file of this.filelist) {
        console.log("Uploading : " + file.fileName)

        crudApi.uploadMedia(this.uploadIdentifier, this.uploadTimestamp, "image/jpeg", file.file)
      }

      this.filelist = []

      setTimeout(this.getDatapoints, 1000)
    },
    /*Every time a new file is selected (both by dropping or choosing from computer)
    * we push them inside our array. This way we keep the previously uploaded files
    * inside. A user can drop a file, then drop another one without losing the first one*/
    onChange(event) {
      const fileArray = [...event.target.files];  //put the files in a temporary array
      fileArray.forEach((file) => {
        const fileName = file.name.replace(/\.[^/.]+$/, "");  //extract filename (no extension) from the file full name
        const extension = file.name.split('.').pop();         //extract extensionfrom the file fullname
        this.filelist.push({fileName, extension, file});      //store selected files and additional data in our array
      })
    },
    /*Remove the file from the list. It will not be uploaded*/
    remove(i) {
      this.filelist.splice(i, 1);
    },
    dragover(event) {
      event.preventDefault();
    },
    drop(event) {
      event.preventDefault();
      this.onChange(event);
    },
    setDetailsVisible(visible) {
      this.detailsVisible = visible
    },
    setMapVisible(visible) {
      this.mapVisible = visible

      if (visible) {
        this.$nextTick(() => {
          this.$refs.mapRef.$mapPromise.then(() => {
            this.handleCenter()
          })
        })

        if (this.$refs.mapRef) {
          this.handleCenter()
        }
      }
    },
    handleCenter() {
      let locations = []

      if (this.tripData.startLocation !== undefined) {
        locations.push(this.tripData.startLocation)
      }
      if (this.tripData.endLocation !== undefined) {
        locations.push(this.tripData.endLocation)
      }

      if (this.events !== undefined && this.events.length > 0) {
        for (let e of this.events) {
          if (e.location !== undefined) {
            locations.push(e.location)
          }
        }
      }

      let bounds = this.getLocationBounds(locations)

      let map = this.$refs.mapRef
      if (bounds !== undefined) {
        map.fitBounds(bounds)
      } else {
        map.panTo(this.getEventsCenter(this.events))
      }
    },
    openInfoWindowTemplate(dataPointIndex, eventIndex) {
      let datapoint = this.datapoints[dataPointIndex]

      let time = formatTime(new Date(Date.parse(datapoint.timestamp)))
      let type = datapoint.events[eventIndex].eventType

      this.infoWindow.position = {lat: datapoint.location.latitude / 100000, lng: datapoint.location.longitude / 100000}
      this.infoWindow.template = `<b>${time}</b><br><br>${type}<br>`
      this.infoWindow.open = true
    },
    openMedia(dataPointIndex, mediaIndex) {
      this.media = undefined
      this.modalVisible = true
      this.downloadMediaId = this.datapoints[dataPointIndex].media[mediaIndex].id

      if (this.datapoints[dataPointIndex].media[mediaIndex].mimeType === "video/mp4") {
        console.log("open video")

        this.media = undefined
        this.mediaVideo = undefined
        crudApi.downloadMedia(this.downloadMediaId).then(res => {

/*
          const blob = new Blob([res.data], { type: "video/mp4" });
          const file = new File([blob], "video.mp4", { type: "video/mp4" });
          this.mediaVideo = URL.createObjectURL(file)
*/

          this.mediaVideo = URL.createObjectURL(new Blob([res.data]))
          this.mediaOptions = { height: 421, playbackRates: [0.7, 1.0, 1.5, 2.0], sources: [{ type: "video/mp4", src: this.mediaVideo }] }
        })
      } else {
        console.log("open picture")

        this.mediaVideo = undefined

        crudApi.downloadMedia(this.downloadMediaId).then(res => this.media = URL.createObjectURL(new Blob([res.data])))
      }
    },
    uploadMedia(datapoint) {
      this.uploadTimestamp = datapoint.timestamp
      this.uploadIdentifier = datapoint.identifier
      this.showFileupload = true
    },
    deleteMedia() {
      this.modalVisible = false

      crudApi.deleteMedia(this.downloadMediaId)

      this.downloadMediaId = undefined

      setTimeout(this.getDatapoints, 1000)
    },
    getMarkerIcon(type) {
      switch(type) {
        case "START":
          return "img/markers/Marker_start_green.png"
        case "FINISH":
          return "img/markers/Marker_stop_red.png"
        case "HARSH_BRAKE":
          return "img/markers/Marker_exclamation_blue.png"
        case "HARSH_ACCELERATION":
          return "img/markers/Marker_exclamation_yellow.png"
        case "OVER_SPEED_START":
          return "img/markers/Marker_start_purple.png"
        case "OVER_SPEED_STOP":
          return "img/markers/Marker_stop_purple.png"
        case "OVER_RPM_START":
          return "img/markers/Marker_start_orange.png"
        case "OVER_RPM_STOP":
          return "img/markers/Marker_stop_orange.png"
        case "IDLE_START":
          return "img/markers/Marker_start_grey.png"
        case "IDLE_STOP":
          return "img/markers/Marker_stop_grey.png"
        default:
          return "img/markers/Marker_exclamation_red.png"
      }
    },
    reverseGeocode(coordinates){
      if (coordinates === undefined) {
        return null
      }

      return axios.get(`https://maps.google.com/maps/api/geocode/json?latlng=${coordinates.latitude/100000},${coordinates.longitude/100000}&key=AIzaSyAq6EpN0DkLaGirArQKtKwxL0ajuddHowQ`)
        .catch(error => {
          console.log(error)
        })
    },
    reverseGeocodeData() {
      if (this.tripData.startLocation !== undefined) {
        this.reverseGeocode(this.tripData.startLocation).then(response => {
          this.tripStartAddress = response.data.results[0].formatted_address
        })
      } else {
        this.tripStartAddress = "Unknown"
      }
      if (this.tripData.endLocation !== undefined) {
        this.reverseGeocode(this.tripData.endLocation).then(response => {
          this.tripEndAddress = response.data.results[0].formatted_address
        })
      } else {
        this.tripEndAddress = "Unknown"
      }
    },
    getLatLngLiteral(location) {
      if (location === undefined) {
        return null
      }

      return new google.maps.LatLng(location.latitude/100000, location.longitude/100000)
    },
    getEventsCenter(events) {
      let minLat, maxLat, minLng, maxLng = undefined

      for (let event of events) {
        let location = event.location

        if (location === undefined) {
          continue
        }

        if (minLat === undefined) {
          minLat = location.latitude
          maxLat = location.latitude
          minLng = location.longitude
          maxLng = location.longitude
        } else {
          if (location.latitude < minLat) {
            minLat = location.latitude
          }
          if (location.latitude > maxLat) {
            maxLat = location.latitude
          }
          if (location.longitude < minLng) {
            minLng = location.longitude
          }
          if (location.longitude > maxLng) {
            maxLng = location.longitude
          }
        }
      }

      if (minLat === undefined) {
        return new google.maps.LatLng(51.84401, 4.89702)
      } else {
        if (minLat === maxLat) {
          return new google.maps.LatLng(minLat/100000, minLng/100000)
        } else {
          return new google.maps.LatLng((maxLat - ((maxLat - minLat)/2))/100000, (maxLng - ((maxLng - minLng)/2))/100000)
        }
      }
    },
    getLocationBounds(locations) {
      if (locations !== undefined && locations.length > 0) {
        const bounds = new google.maps.LatLngBounds()
        for (let l of locations) {
          bounds.extend(this.getLatLngLiteral(l))
        }
        return bounds
      }
      return undefined
    },
  },
  watch: {
    tripData: function() {
      this.reverseGeocodeData()
    },
    datapoints: function() {
      let result = []
      for (let r of this.datapoints) {
        if (r.location !== undefined) {
          result.push(this.getLatLngLiteral(r.location))
        }
      }

      this.route = result
    }
  }
}
</script>

<style lang="scss">
div#add-attachments-modal {
  div.modal-dialog {
    transition: max-width 0.3s ease-out, transform 0.3s ease-out;
  }
  .col.file-drop-column {
    flex-shrink: 1;
  }
  div.file-drop-area {
    border: 2px dashed rgba(0, 0, 0, 0.25);
    input.file-input {
      position: absolute;
      height: 0;
    }
  }
}
</style>
